import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, LoadingController, AlertController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { Storage } from '@ionic/storage';
import { AppConfig } from '../../app/app-config';
import { CartserviceProvider } from '../../providers/cartservice';
import { CartProduct } from '../../providers/cartservice';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { regexValidators } from '../validators/validators';
import { UserserviceProvider } from '../../providers/userservice';

@Component({
  selector: 'page-cart',
  templateUrl: 'cart.html',
})
export class CartPage {
    cart: Array<CartProduct>;
    total: number;
    productInCart: any;
    subTotal: number;
    shipTotal: number;
    loadingModal: any;
    isEmpty: boolean;
    errorModal: any;
    bezeichnung: string;
    name: string;
    email: string;
    tel: string;
    agb: boolean;
    myRequestForm: FormGroup;
    cartItems: Array<>;

  constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, public storage: Storage, public appConfig: AppConfig, public cartService: CartserviceProvider, public alertCtrl: AlertController, private formBuilder: FormBuilder, public userService: UserserviceProvider, public loadingCtrl: LoadingController) {
  
this.myRequestForm = this.formBuilder.group({
 name: [   'Hans Muster', Validators.compose([
     Validators.pattern(regexValidators.name),
     Validators.required
   ])
   ],
  email: [   'hans.muster@email.ch', Validators.compose([
     Validators.pattern(regexValidators.email),
     Validators.required
   ])
   ],
 tel: [   '0790012345', Validators.compose([
     Validators.pattern(regexValidators.tel),
     Validators.required
   ])
   ],
  agb: ['', Validators.requiredTrue]
});
  
  }
  
  ionViewWillEnter() { 
  this.isEmpty = false;


    }

  ionViewDidLoad() {
     this.checkCart();
    console.log('ionViewDidLoad CartPage');
  }
  
  doRefresh(refresher) {
   this.checkCart();
   refresher.complete();
   }
   
    goHome() {
        this.navCtrl.parent.select(0);
    }

    ionViewDidEnter() {

    }
    
    deleteFromCartConfirmed(pid){
    event.stopPropagation();
        var findIndex = this.cart.findIndex((element) => {
            return element.bezeichnung == pid;
        });
        if (findIndex != -1) {
            this.cart.splice(findIndex, 1);
            if (this.cart.length == 0) {
                this.isEmpty = true;
            }
            this.storage.set('MyProduct', JSON.stringify(this.cart));
        }
    this.cartService.cartBage = this.cart.length;
    }
    
    deleteFromCart(pid) {
    const confirm = this.alertCtrl.create({
      title: 'Produkt löschen',
      message: 'Sind Sie sicher, dass Sie dieses Produkt löschen möchten?',
      buttons: [
        {
          text: 'Nein',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Ja',
          handler: () => {
            console.log('Agree clicked');
            this.deleteFromCartConfirmed(pid);
          }
        }
      ]
    });
    confirm.present();
  }
  
  
  checkCart(){
     this.subTotal = 0;
     this.total = 0;
     this.shipTotal = 0;
     this.storage.get('MyProduct').then((data) => {
                if (data) {
                 this.cart = JSON.parse(data);
                 console.log(this.cart);
                }                 
                else {
                    this.isEmpty = true;
                }
        });
  }
  
  onSubmit() {
   /*this.name= this.myRequestForm.get('name').value;
   this.tel= this.myRequestForm.get('tel').value;
   this.email= this.myRequestForm.get('email').value;
   var personalData = JSON.stringify({ name: this.name, tel: this.tel, email: this.email });*/
   this.personalData = this.myRequestForm.value;
   
   this.checkCart();
   console.log(this.personalData, this.cart);
      
   this.presentLoading();
   this.userService.sendMail(this.cart, this.personalData).subscribe((data : any) =>
      {
          this.griffes = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });
     }
        
     presentLoading() {
        this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        });
        this.loading.present();
    }

}


// WEBPACK FOOTER //
// ./src/pages/cart/cart.ts